import { useState } from 'react';
import translate from '../../functions/translate';
import useViewport from '../../hooks/use.viewport';
import the from '../../objects/the';
import Button from '../button';
import InputField from '../input.field';
import MedicareNumberDialog from '../medicare.number.dialog';
import TranslatedSpan from '../translated.span';

interface MedicareNumberSectionProps {
    onChange: (event: any) => void
    value: string
    errorMessage: string | null
    forceError: boolean
    onBlur: () => void
    inputRef: (ref: any) => void
}

const MedicareNumberSection = (props: MedicareNumberSectionProps) => {
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const {width} = useViewport();

    const closeDialog = () => setDialogIsOpen(false);

    const openDialogButton = <Button
        analyticsDescription={'open Medicare Number dialog'}
        color="blue"
        displayAs="link"
        onClick={() => setDialogIsOpen(true)}
        style={{
            padding: 0,
            textAlign: 'left',
        }}
    >
        <TranslatedSpan
            english={'Where can I find my Medicare Number?'}
            style={{
                fontFamily: 'Rubik',
                fontSize: width < the.minimumMediumViewportWidth ? 14 : 16,
                fontWeight: 400,
                lineHeight: width < the.minimumMediumViewportWidth ? 1 : 1.3,
                textTransform: 'none',
            }}
        />
    </Button>

    return <>
        <InputField
            aria-invalid={(!!props.errorMessage).toString()}
            errorMessage={props.errorMessage}
            hint={openDialogButton}
            inputRef={props.inputRef}
            label={translate('Medicare Number')}
            name={translate('Medicare Number')}
            onBlur={props.onBlur}
            onChange={props.onChange}
            value={props.value}
        />
        <MedicareNumberDialog isOpen={dialogIsOpen} onExit={closeDialog}/>
    </>;
}

export default MedicareNumberSection;